import { render, staticRenderFns } from "./ProjectTeamMemberForm.vue?vue&type=template&id=752b679d"
import script from "./project-team-member-form.ts?vue&type=script&lang=ts&external"
export * from "./project-team-member-form.ts?vue&type=script&lang=ts&external"
import style0 from "./project-team-member-form.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports